import React, { useState, useEffect, Fragment } from "react"
import PropTypes from "prop-types"
import { Row, Col, Button, Label } from "reactstrap"
import { withRouter } from "react-router-dom"
import { useSelector } from "react-redux"
import {
  AvForm,
  AvField,
  AvInput,
  AvGroup,
} from "availity-reactstrap-validation"
import {
  useGetProfilesCmoQuery,
  useGetZonasComercialesCmoQuery,
  useGetGerentesCmoQuery,
  useGetPuestosCmoQuery,
} from "../../store/api/usersApi"
import { useGetCustomersCmoQuery } from "../../store/api/customersApi"

const HubUsersCmo = props => {
  const insert = props.insert ?? true
  const [record, setRecord] = useState(false)
  const [formError, setFormError] = useState(false)

  const [profileCmo, setProfileCmo] = useState(
    props.user?.profileIdCmo ?? 0
  )
  const [zonaCmo, setZonaCmo] = useState(
    props.user?.shoppingAreaIdCmo ?? ""
  )
  const [gerenteCmo, setGerenteCmo] = useState(
    props.user?.gerenteCmo ?? ""
  )
  const [clienteCmo, setClienteCmo] = useState(
    props.user?.clienteCmo ?? ""
  )
  const [puestoCmo, setPuestoCmo] = useState(
    props.user?.puestoCmo ?? ""
  )

  const {
    loading,
    insertedUserError,
    editUserError,
  } = useSelector(state => ({
    loading: state.UserAdd.loading,
    insertedUserError: state.UserAdd.error,
    editUserError: state.UserEdit.error,
  }))

  const { data: profilesCmo = [] } = useGetProfilesCmoQuery()
  const { data: zonasCmo = [] } = useGetZonasComercialesCmoQuery()
  const { data: gerentesCmo = [] } = useGetGerentesCmoQuery()
  const { data: clientesCmo = [] } = useGetCustomersCmoQuery()
  const { data: puestosCmo = [] } = useGetPuestosCmoQuery()

  useEffect(() => {
    if (!props.user) return
    setProfileCmo(parseInt(props.user.profileIdCmo) || 0)
    setZonaCmo(props.user.shoppingAreaIdCmo ?? "")
    setGerenteCmo(props.user.gerenteCmo ?? "")
    setClienteCmo(props.user.clienteCmo ?? "")
    setPuestoCmo(props.user.puestoCmo ?? "")
  }, [props.user])

  const handleProfileChange = evt => {
    const val = parseInt(evt.target.value) || 0
    setProfileCmo(val)
    setZonaCmo("")
    setGerenteCmo("")
    setClienteCmo("")
    setPuestoCmo("")
  }

  const handleSubmit = (event, errors, values) => {
    if (!record) {
      props.onConfirm({})
      return
    }

    if (errors.length > 0) {
      setFormError(true)
      return
    }
    setFormError(false)

    const result = {
      profileIdCmo: parseInt(values.profileIdCmo),
    }

    if (profileCmo === 4) {
      result.shoppingAreaIdCmo = parseInt(values.shoppingAreaIdCmo)
    }

    if (profileCmo === 6) {
      result.gerenteCmo = parseInt(values.gerenteCmo)
    }

    if (profileCmo === 7) {
      result.clienteCmo = values.clienteCmo
      result.puestoCmo = parseInt(values.puestoCmo)
    }

    props.onConfirm(result)
  }

  return (
    <AvForm className="form-horizontal" onSubmit={handleSubmit}>
      {insert && insertedUserError !== "" && (
        <div className="alert alert-danger">
          Ocurrió un error al registrar usuario: {insertedUserError.error}
        </div>
      )}
      {!insert && editUserError !== "" && (
        <div className="alert alert-danger">
          Ocurrió un error al editar usuario: {editUserError.error}
        </div>
      )}
      {formError && (
        <div className="alert alert-danger">
          Por favor corrija los errores en el formulario antes de continuar.
        </div>
      )}
      <Row>
        <Col>
          <h3 className="mb-4">Certificación de Mano de Obra Fester</h3>
        </Col>
      </Row>
      <Row>
        <Col size={{ span: 4, offset: 4 }} className="mb-4">
          <AvGroup check>
            <AvInput
              name="celf"
              type="checkbox"
              checked={record}
              onChange={value => setRecord(value.target.checked)}
            />
            <Label for="celf">
              El usuario será participante en esta aplicación.{" "}
              <a
                href="https://www.henkel.mx/declaracion-de-proteccion-de-datos#pageID=560414"
                target="_blank"
                rel="noreferrer"
              >
                Leer TyC
              </a>
              .
            </Label>
          </AvGroup>
        </Col>
      </Row>
      {record && (
        <Fragment>
          <Row className="mb-3">
            <Col md={12}>
              <AvField
                name="profileIdCmo"
                value={profileCmo || ""}
                label="* Perfil:"
                className="form-control"
                type="select"
                onChange={handleProfileChange}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Este campo es requerido",
                  },
                }}
              >
                <option value="">-- Seleccione perfil --</option>
                {profilesCmo.map(profile => (
                  <option
                    value={profile.id_perfil}
                    key={profile.id_perfil}
                  >
                    {profile.nombre_perfil}
                  </option>
                ))}
              </AvField>
            </Col>
          </Row>

          {profileCmo === 4 && (
            <Row className="mb-3">
              <Col md={12}>
                <AvField
                  name="shoppingAreaIdCmo"
                  value={zonaCmo}
                  label="* Zona comercial:"
                  className="form-control"
                  type="select"
                  onChange={evt => setZonaCmo(evt.target.value)}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Este campo es requerido",
                    },
                  }}
                >
                  <option value="">-- Seleccione zona comercial --</option>
                  {zonasCmo.map(zona => (
                    <option
                      value={zona.id_zona_comercial}
                      key={zona.id_zona_comercial}
                    >
                      {zona.nombre_zona_comercial}
                    </option>
                  ))}
                </AvField>
              </Col>
            </Row>
          )}

          {profileCmo === 6 && (
            <Row className="mb-3">
              <Col md={12}>
                <AvField
                  name="gerenteCmo"
                  value={gerenteCmo}
                  label="* Gerente comercial:"
                  className="form-control"
                  type="select"
                  onChange={evt => setGerenteCmo(evt.target.value)}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Este campo es requerido",
                    },
                  }}
                >
                  <option value="">-- Seleccione gerente --</option>
                  {gerentesCmo.map(g => (
                    <option
                      value={g.id_usuario}
                      key={g.id_usuario}
                    >
                      {g.nombre_completo}
                    </option>
                  ))}
                </AvField>
              </Col>
            </Row>
          )}

          {profileCmo === 7 && (
            <Fragment>
              <Row className="mb-3">
                <Col md={12}>
                  <AvField
                    name="clienteCmo"
                    value={clienteCmo}
                    label="* Distribuidor:"
                    className="form-control"
                    type="select"
                    onChange={evt => setClienteCmo(evt.target.value)}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Este campo es requerido",
                      },
                    }}
                  >
                    <option value="">-- Seleccione distribuidor --</option>
                    {clientesCmo.map(c => (
                      <option
                        value={c.idh_cliente}
                        key={c.id_cliente}
                      >
                        {c.nombre_cliente}
                      </option>
                    ))}
                  </AvField>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12}>
                  <AvField
                    name="puestoCmo"
                    value={puestoCmo}
                    label="* Puesto:"
                    className="form-control"
                    type="select"
                    onChange={evt =>
                      setPuestoCmo(evt.target.value)
                    }
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Este campo es requerido",
                      },
                    }}
                  >
                    <option value="">-- Seleccione puesto --</option>
                    {puestosCmo.map(p => (
                      <option
                        value={p.id_puesto}
                        key={p.id_puesto}
                      >
                        {p.nombre_puesto}
                      </option>
                    ))}
                  </AvField>
                </Col>
              </Row>
            </Fragment>
          )}
        </Fragment>
      )}
      <Row className="mb-3">
        <Col xl={8} lg={8} md={8} sm={8} xs={0}></Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={6}>
          <button
            type="button"
            onClick={() => props.onCancel()}
            className="btn btn-warning btn-block"
          >
            Regresar
          </button>
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={6}>
          <Button
            className={`float-right ${loading ? "disabled" : ""} btn-block`}
            type="submit"
          >
            {!loading && (
              <span>{props.showNext ? "Siguiente" : "Finalizar"}</span>
            )}
            {loading && (
              <span>
                {props.showNext ? "Guardando..." : "Finalizando..."}
              </span>
            )}
          </Button>
        </Col>
      </Row>
    </AvForm>
  )
}

HubUsersCmo.propTypes = {
  insert: PropTypes.bool,
  user: PropTypes.object,
  history: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  showNext: PropTypes.bool,
}

export default withRouter(HubUsersCmo)
